import React from 'react';
import cn from 'classname';

const OrdinaryRow = (props) => {
	const {
		row, checkLimitedAnalizedRequest, expandedIds, toggleExpanded,
		isProfitVisible, toggleExpandedHistory, expandedHistoryIds
	} = props;

	return (
		<tr
			className={cn({
				'analized_not_ok': row.is_limited_analized_ok === false,
				'analized_ok': row.is_limited_analized_ok === true
			})}
		>
			<td
				className={`id fixed-col ${cn({  'width-200': true })}` }
			>
				{
					!row.isNested &&
					<div>
						<p><span>{row.manager_email}</span></p>
						<p><span>{row.affiliate_email}</span></p>
						<p><span>Affiliate id: ({row.affiliate_id})</span></p>
						<p><span>{row.location_name}</span></p>
						<p><span>{row.offer_name}</span> </p>
						<p><span>{row.traffic_source}</span> </p>
						{row.campaign_id && <p><span>Campaign id: {row.campaign_id}</span> </p>}
					</div>
				}
				{
					row.idsCount > 1 && !row.isNested &&
					<p>
						<button
							className="btn width-100-p height-40 hover-pointer ui-btn ui-btn-cancel margin-top-5"
							onClick={toggleExpanded.bind(null, row.id)}
						>
							{expandedIds.includes(row.id) ? 'Сollect ↑' : 'Expand ↓'}
						</button>
					</p>
				}

				{
					!!row.ref_garant_id && !row.isHistoryRow && Number(row.row_number) === 1 &&
					<p>
						<button
							className="btn width-100-p height-40 hover-pointer ui-btn ui-btn-cancel margin-top-5"
							onClick={toggleExpandedHistory.bind(null, row.id)}
						>
							Task history {expandedHistoryIds.includes(row.id) ? 'collect ↑' : 'expand ↓'}
						</button>
					</p>
				}
			</td>
			<td className="width-100">
				<span>{row.id}</span>
			</td>
			<td className="width-100">
				<p>{row.starts_at}</p>
				<p>{row.ends_at}</p>
			</td>
			<td className="width-100">
				<span>{row.created_at}</span>
			</td>
			<td className="width-100">
				{row.start_leads_setting && row.start_leads_setting
					.sort((a, b) => a.start_leads_count > b.start_leads_count ? 1 : -1)
					.map((item, index) =>
						<p key={index}>{item.start_duration}: {item.start_leads_count}</p>
					)}
			</td>
			<td className="width-100">
				{
					!!Number(row.non_trash_leads_count) &&
					<span>
						{Math.floor(1000 * Number(row.approved_leads_count)/Number(row.non_trash_leads_count))/10}
					</span>
				}
			</td>
			<td className="width-100">
				<span>{row.sids && row.sids.join(',')}</span>
			</td>
			<td className="width-100">
				<span>{row.duration && Object.values(row.duration)[0]}</span>
				<span> {row.duration && Object.keys(row.duration)[0]}</span>
			</td>
			<td className="width-100">
				<span>{Math.round(row.target_percent)}%</span>
			</td>
			{
				isProfitVisible &&
				<td className="width-100">
					<span>{Math.round(row.profit_usd)}</span>
				</td>
			}
			<td className="fixed-col-right actions">
				<div className="display-flex flex-center">
					<span
						className="icon-approved-common margin-0-10"
						onClick={checkLimitedAnalizedRequest.bind(null, row.id, true)}
					/>
					<span
						className="icon-rejected-common margin-0-10"
						onClick={checkLimitedAnalizedRequest.bind(null, row.id, false)}
					/>
				</div>
			</td>
		</tr>
	);
}
;

export default OrdinaryRow;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/limited-garants-analysis/list/components/table/row.js